import {TeachBlock, TeachBlockPage} from "./types";
const base = process.env.PUBLIC_URL || ``;

export const branch0Alex = {
    start: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'AlexAnalyzes',
        cardClick: 'patientAlexCard',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    patientAlexCardFirst: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AlexAnalyzes",
            closeClick: "tuktukAlex",
            pages: [`${base}/images/patient_alex_card1.png`, `${base}/images/patient_alex_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAlexCard: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AlexAnalyzesAfter",
            closeClick: "alexFirstQuestion",
            pages: [`${base}/images/patient_alex_card1.png`, `${base}/images/patient_alex_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    tuktukAlex: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'Слабый и медленный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'enterAlex', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterAlex: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexEnter.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите, рассказывайте.", type: "nextStep", gotoStep:'enterAlex2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterAlex2: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Здравствуйте, доктор! Я тут узнал, что у меня редкая болезнь — ПНГ. Я пока к вам собирался, весь интернет проштудировал. Это мне теперь все время привязанным к больнице быть? Я прочитал, что все лечение проходит через терапию С5 или как-то так, и надо ходить на инфузии постоянно, и они долгие. Значит, весь день выпадает. ',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '120px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexFirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexFirstQuestion: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'Алексей Игнатьевич, вы заранее не беспокойтесь. Существует много разных видов терапии ПНГ, не только ингибиторы С5. Давайте сначала проведем осмотр, а потом я вам все расскажу подробнее.  ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexQuestions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'AlexAnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexQuestions: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Усталость и анемия", type: "nextStep", gotoStep:'alexQuestion1', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Тромбозы", type: "nextStep", gotoStep:'alexQuestion2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Отечность ног", type: "nextStep", gotoStep:'alexQuestion3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'alexQuestion4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'alexQuestion5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'alexQuestion6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'alexFirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexQuestion1: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Мне все время стыдно это говорить, но устаю я сильно. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexQuestion2: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexQuestion3: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexQuestion4: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Доктор, я чувствую постоянную усталость, которая не проходит ни днем, ни ночью. Даже после сна нет сил, а любая мелочь кажется тяжелой работой. Когда поднимаюсь по лестнице или просто иду по улице, появляется сильная одышка, приходится останавливаться, чтобы перевести дыхание. Иногда кажется, что даже разговор отнимает энергию. Я уже не помню, когда чувствовал себя бодрым.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexQuestion5: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Боль периодически появляется, а затем сама проходит. Точно не могу сказать где.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexQuestion6: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Иногда утром моча становится настолько темной, что я пугаюсь. Это происходит время от времени, и я не понимаю, что это значит.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexQuestions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    AlexAnalyzes: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAlexCardFirst",
            nextClick: "tuktukAlex",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alex_enter_1_table.jpg`],
                [`${base}/images/analiz_alex_enter_2_table.jpg`],
                [`${base}/images/analiz_alex_enter_3_table.jpg`],
                [`${base}/images/analiz_alex_enter_4_table.jpg`],
                [`${base}/images/analiz_alex_enter_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [680],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    AlexAnalyzesAfter: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAlexCard",
            nextClick: "alexFirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alex_enter_1_table.jpg`],
                [`${base}/images/analiz_alex_enter_2_table.jpg`],
                [`${base}/images/analiz_alex_enter_3_table.jpg`],
                [`${base}/images/analiz_alex_enter_4_table.jpg`],
                [`${base}/images/analiz_alex_enter_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [680],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterQuestion: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'alexEnterOsmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterFisk', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterOsmotr: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'alexEnterOsmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'alexEnterOsmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'alexEnterOsmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterFisk', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterOsmotr1: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterOsmotr2: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'Наблюдается бледность кожи и иктеричность склер.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterOsmotr3: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexEnterOsmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterFisk: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Что скажете, доктор? Каковы мои перспективы? У меня работа сложная, я нефтяник. Я если буду все время по больницам — так это мне профессию надо менять?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Рассказать про монотерапию", type: "nextStep", gotoStep:'alexEnterAfterFisk2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterFisk2: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'Алексей Игнатьевич, судя по тому, что вы говорите, вы действительно изучили вопрос и вы правы: терапия ингибиторами С5 предполагает довольно частые инфузии, и это серьезно нарушает привычную жизнь. Но существует и терапия в капсулах.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterFisk3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterFisk3: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'А если капсулы принимать, и никаких инфузий не нужно? ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterFisk4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterFisk4: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'Инфузий не нужно, потому что иптакопан - монотерапия. Только капсулы и приходить на контрольный осмотр 2 раза в год. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterItems', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterItems: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Доктор, а к какому классу препаратов относится иптакопан?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Ингибитор C3", type: "nextStep", gotoStep:'alexEnterItemsIncorrect', value: false, redColor: false, answered: false},
            {text: "Ингибитор фактора B", type: "nextStep", gotoStep:'alexEnterItemsCorrect', value: false, redColor: false, answered: false},
            {text: "Ингибитор фактора D", type: "nextStep", gotoStep:'alexEnterItemsIncorrect', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterItemsCorrect: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Доктор, а к какому классу препаратов относится иптакопан?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Ингибитор C3", type: "", gotoStep:'', value: false, redColor: false, veryRedColor: true, answered: false},
            {text: "Ингибитор фактора B", type: "", gotoStep:'', value: false, redColor: false, greenColor: true, answered: false},
            {text: "Ингибитор фактора D", type: "", gotoStep:'', value: false, redColor: false, veryRedColor: true, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterCorrect', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterItemsIncorrect: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Доктор, а к какому классу препаратов относится иптакопан?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Ингибитор C3", type: "", gotoStep:'', value: false, redColor: false, veryRedColor: true, answered: false},
            {text: "Ингибитор фактора B", type: "", gotoStep:'', value: false, redColor: false, greenColor: true, answered: false},
            {text: "Ингибитор фактора D", type: "", gotoStep:'', value: false, redColor: false, veryRedColor: true, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems1', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterCorrect: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems1', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems1: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'В качестве монотерапии ПНГ применяется препарат Иптакопан. Данный препарат селективно ингибирует фактор В альтернативного пути системы комплемента, ключевого звена патогенеза заболевания. Такой механизм позволяет предотвратить разрушение эритроцитов иммунной системой.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Ссылка", type: "nextStep", gotoStep:'alexEnterAfterItems1Link', value: false, redColor: false, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems1Link: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта® </strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexEnterAfterItems1', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems2: {
        patient: 'Alex',
        branch: 0,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступен новый материал! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Читать справочник", type: "nextStep", gotoStep:'alexEnterDocs', value: false, redColor: true, answered: false},
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterDocs: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "alexGematogenEnter",
            pages: [
                {image: `${base}/images/alex_teach_enter_1.png`, scroll: true},
                {image: `${base}/images/alex_teach_enter_2.png`, scroll: true},
                {image: `${base}/images/alex_teach_enter_3.png`, scroll: true},
            ]
        }
    },
    alexGematogenEnter: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexEnterAfterItems2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems3: {
        patient: 'Alex',
        branch: 0,
        name: 'Надя',
        text: 'Доктор, а у меня тут брошюра лежит — давайте ее почитаем? Иптакопан — это представитель нового класса патогенетической терапии. Действие направлено на фактор B.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems4: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'А нужно как-то отдельно подготовиться к началу приема? Сколько раз в день нужно капсулы принимать?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems5', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems5: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'Принимайте по 1 капсуле (200мг) 2 раза в день. Никакой специальной подготовки не требуется, кроме...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems6', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems6: {
        patient: 'Alex',
        branch: 0,
        name: 'Надя (шепотом)',
        text: 'Доктор, а вакцинация?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterItems7', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterItems7: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'Надя, вы сегодня быстры как молния! Это я и собираюсь сказать. Да. Единственное, что вам нужно сделать — это пройти вакцинацию от ...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Обратиться к справочнику", type: "nextStep", gotoStep:'alexEnterDocs2', value: false, redColor: true, answered: false},
            {text: "Проверить свои знания", type: "nextStep", gotoStep:'alexEnterTest', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterDocs2: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "alexGematogenEnter",
            pages: [
                {image: `${base}/images/alex_teach_enter_11.png`, scroll: true},
                {image: `${base}/images/alex_teach_enter_12.png`, scroll: true},
            ]
        }
    },
    alexGematogenEnter2: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexEnterAfterItems7', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterTest: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: true,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: `${base}/images/aksinya_questions1.png`,
        stepSound: '',
        rating: 0,
        buttons: [],
        question: {
            title: "Какие обязательные из списка вакцины следует пройти перед приемом Иптакопана?",
            result: "<strong>ОХЛП: Общая характеристика лекарственного препарата Фабхальта®</strong><br>ЛП-№(006928)-(РГ-RU) от 19.09.2024",
            nextStep: "alexEnterAfterTest",
            nextStepCorrect: "alexEnterCorrect",
            answers: [
                {name: "Грипп", correct: true},
                {name: "Менингококк", correct: false},
                {name: "Пневмококк", correct: true},
                {name: "Полиомиелит", correct: false}
            ]
        },
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterCorrect: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/AlexCabinet.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterTest', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterTest: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'В общем, делайте прививки, начинайте лечение. Я записал Вас на повторный прием.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterAfterTest2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterAfterTest2: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Понял. Все сделаю. Тогда отставить волнение!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexEnterFinish', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexEnterFinish: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "closeTelegramBot", gotoStep:'alexVisit2Cabinet', value: false, redColor: false, answered: false, patient: "Alex"},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },


    alexVisit2Cabinet: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: 'alexVisit2CardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2CardFirst: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "alexVisit2Analyzes",
            closeClick: "alexVisit2tuktuk",
            pages: [`${base}/images/patient_alex_card1_2.png`, `${base}/images/patient_alex_card2_2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Card: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "alexVisit2AnalyzesAfter",
            closeClick: "alexVisit2FirstQuestion",
            pages: [`${base}/images/patient_alex_card1_2.png`, `${base}/images/patient_alex_card2_2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2tuktuk: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'Тройной уверенный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {text: "Входите 💡", type: "nextStep", gotoStep:'alexVisit2enter', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2enter: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexEnter2.jpg`,
        buttons: [
            {text: "Здравствуйте, проходите, пожалуйста.", type: "nextStep", gotoStep:'alexVisit2enter2', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2enter2: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Доктор! Я хочу скорее рассказать вам: я тут на днях зашел домой и вдруг осознал, что у меня после работы остаются силы!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexVisit2FirstQuestion', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2FirstQuestion: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'Алексей Игнатьевич, очень радостно слышать, что вы себя гораздо лучше чувствуете! Расскажите более детально о своем самочувствии.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexVisit2Questions', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Посмотреть анализы", type: "nextStep", gotoStep:'alexVisit2AnalyzesAfter', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'alexVisit2AfterQuestion', value: false, redColor: false, answered: true, canDisabled: false, startInvisible: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Questions: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Усталость и анемия", type: "nextStep", gotoStep:'alexVisit2Question1', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Тромбозы", type: "nextStep", gotoStep:'alexVisit2Question2', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Отечность ног", type: "nextStep", gotoStep:'alexVisit2Question3', value: false, redColor: false, answered: false, width: 'calc(50% - 8px)', canDisabled: true, page: 1},
            {text: "Физические нагрузки", type: "nextStep", gotoStep:'alexVisit2Question4', value: false, redColor: false, answered: false, canDisabled: true, page: 1},
            {text: "Боль в животе", type: "nextStep", gotoStep:'alexVisit2Question5', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "Темный цвет мочи по утрам", type: "nextStep", gotoStep:'alexVisit2Question6', value: false, redColor: false, answered: false, canDisabled: true, page: 2},
            {text: "arrow_prev", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "arrow_next", type: "nextStep", gotoStep:'', value: false, redColor: false, answered: true, width: 'calc(50% - 8px)', canDisabled: false},
            {text: "Далее", type: "nextStep", gotoStep:'alexVisit2FirstQuestion', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Question1: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Я теперь на работе прекрасно себя чувствую: перерыв на обед — и все, дальше за дела.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexVisit2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Question2: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexVisit2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Question3: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexVisit2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Question4: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Стало ощутимо лучше. На холм около дома я уже забираюсь спокойно. Иногда уже оборачиваюсь и понимаю, что раньше он в меня ужас вселял, а теперь могу и не заметить. Готовлюсь к следующему этапу — обходиться без лифта!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexVisit2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Question5: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Не припомню такого, кажется, не было. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexVisit2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Question6: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Нет, доктор, больше не было таких эпизодов.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Опросить", type: "nextStep", gotoStep:'alexVisit2Questions', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Analyzes: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexCabinet2.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "alexVisit2CardFirst",
            nextClick: "alexVisit2tuktuk",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alex_visit2_1_table.jpg`],
                [`${base}/images/analiz_alex_visit2_2_table.jpg`],
                [`${base}/images/analiz_alex_visit2_3_table.jpg`],
                [`${base}/images/analiz_alex_visit2_4_table.jpg`],
                [`${base}/images/analiz_alex_visit2_5_table.jpg`]
            ],
            analyzesHeights: [
                [418],
                [704],
                [366],
                [472],
                [353]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2AnalyzesAfter: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexCabinet2.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "alexVisit2Card",
            nextClick: "alexVisit2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alex_visit2_1_table.jpg`],
                [`${base}/images/analiz_alex_visit2_2_table.jpg`],
                [`${base}/images/analiz_alex_visit2_3_table.jpg`],
                [`${base}/images/analiz_alex_visit2_4_table.jpg`],
                [`${base}/images/analiz_alex_visit2_5_table.jpg`]
            ],
            analyzesHeights: [
                [418],
                [704],
                [366],
                [472],
                [353]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2AfterQuestion: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Физикальный осмотр", type: "nextStep", gotoStep:'alexVisit2Osmotr', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'alexVisit2Next', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Osmotr: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Пульс", type: "nextStep", gotoStep:'alexVisit2Osmotr1', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Кожа", type: "nextStep", gotoStep:'alexVisit2Osmotr2', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Пальпация живота", type: "nextStep", gotoStep:'alexVisit2Osmotr3', value: false, redColor: false, answered: false, canDisabled: true},
            {text: "Далее", type: "nextStep", gotoStep:'alexVisit2Next', value: false, redColor: false, answered: true, canDisabled: true},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Osmotr1: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexVisit2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Osmotr2: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexVisit2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Osmotr3: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'В норме',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'alexVisit2Osmotr', value: false, redColor: false, answered: false},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Next: {
        patient: 'Alex',
        branch: 0,
        name: 'Алексей',
        text: 'Я же вам главную новость не рассказал: меня на работе повысили! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexVisit2Next2', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Next2: {
        patient: 'Alex',
        branch: 0,
        name: 'Надя',
        text: 'Ой, как здорово! ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:'alexVisit2Next3', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Next3: {
        patient: 'Alex',
        branch: 0,
        name: 'Вы',
        text: 'Новости действительно очень хорошие.<br>Однако, Алексей, очень важно сейчас сфокусироваться на поддержании достигнутых результатов, поэтому соблюдать режим приема препарата, обязательно регулярно приходить на осмотр, чтобы своевременно реагировать на любые изменения в Вашем состоянии.<br><br>Удачи вам!    ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexCabinet2.jpg`,
        buttons: [
            {text: "Закончить приём", type: "nextStep", gotoStep:'alexVisit2Finish', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Finish: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '<strong>Пациент стабилен! Отличная работа! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐️<br><br>📈 Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Закрыть", type: "nextStep", gotoStep:'alexVisit2Finish2', value: false, redColor: false, answered: false, patient: ""},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Finish2: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: '<strong>Вот и все! Отличная работа!<br> + 60 баллов<br><br>🏆 Ваш рейтинг: ???⭐</strong>️',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 60,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "Закрыть", type: "nextStep", gotoStep:'alexVisit2Finish3', value: false, redColor: false, answered: false, patient: ""},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Finish3: {
        patient: 'Alex',
        branch: 0,
        name: 'Надя',
        text: 'Спасибо Вам, доктор! От всего Северокрайска! Надеюсь, увидимся однажды на каком-нибудь врачебном симпозиуме... Да, я ведь поступила на лечебный факультет! И за вдохновение тоже Вам спасибо. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {text: "До свидания, Надя.\n И тебе спасибо за все.", type: "nextStep", gotoStep:'alexVisit2Finish4', value: false, redColor: false, answered: false}
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexVisit2Finish4: {
        patient: 'Alex',
        branch: 0,
        name: '',
        text: 'Ваша командировка в Северокрайске на этом заканчивается.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {text: "Отправиться домой", type: "closeTelegramBot", gotoStep:'closeTelegramBot', value: false, redColor: false, answered: false, patient: ""},
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    }


}
